var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._t("pre-nav"),_c('li',[_c('router-link',{attrs:{"to":{ 'name': 'carrier-perks' }}},[_vm._v("Carrier Perks")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }